import { useCallback } from 'react';

import { webAuthnConfig } from '../config';

export const useRelyingPartyId = () =>
  useCallback(() => {
    const origins = new Set(webAuthnConfig.origins);
    const environmentRelyingPartyId = String(import.meta.env.VITE_APP_RELYING_PARTY_ID);

    // eslint-disable-next-line @typescript-eslint/naming-convention -- External API
    const relyingPartyID =
      origins.has(window.location.origin) || window.location.origin.includes(environmentRelyingPartyId)
        ? environmentRelyingPartyId
        : window.location.hostname;

    return relyingPartyID;
  }, []);
